import antdZh from "antd/lib/locale-provider/zh_CN";
import appLocaleData from "react-intl/locale-data/zh";
import enMessages from "../locales/en_US.json";
import zhMessages from "../locales/zh-Hans.json";

const ZhLan = {
  messages: {
    ...enMessages,
    ...zhMessages
  },
  antd: antdZh,
  locale: 'zh',
  data: appLocaleData
};
export default ZhLan;
